export enum ProcessControlType {
  REPORT = 'REPORT',
  BILLET_GENERATE = 'BILLET_GENERATE',
  RETURN_FILE_IMPORT = 'RETURN_FILE_IMPORT',
  INVOICE_GENERATE = 'INVOICE_GENERATE',
  MARINA_ORDER_GENERATE = 'MARINA_ORDER_GENERATE',
  TUITION_GENERATE = 'TUITION_GENERATE',
  ENOTAS_NFE_GENERATE = 'ENOTAS_NFE_GENERATE',
  INVOICE_CANCEL = 'INVOICE_CANCEL',
}
